import { useCallback, useEffect, useMemo } from 'react';
import useRequestContext from '../context/requestContext';
import useAuth from '../Services/useAuth';
import { getMyRequest } from '../Services/httpCalls';

export default function useUser() {
  const { request, setRequest } = useRequestContext();
  const { getUser, handleTokenExpiration } = useAuth();

  const afm = getUser()?.afm;
  const isAdmin = getUser()?.is_admin === 1;

  const getRequest = useCallback(async () => {
    try {
      if (!afm || isAdmin) return;

      const resp = await getMyRequest();
      const myRequest = resp?.data?.requests;
      // Context keeps the array shape expected by its consumers.
      setRequest(myRequest ? [myRequest] : []);
    } catch (error) {
      handleTokenExpiration(error?.response?.status);
      console.error('Error fetching user request:', error);
    }
  }, [afm, isAdmin, setRequest]);

  useEffect(() => {
    if (request.length > 0) return;
    getRequest();
  }, []);

  const isNewUser = useMemo(() => request?.length === 0, [request]);

  return { isNewUser };
}
